import type { PetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type PetitionPageMediaMentionsPlacementExperiment =
	PetitionDetailsPageUserData['experiments']['petitionPageMediaMentionsPlacement'];

type Result = Readonly<{
	experiment: PetitionPageMediaMentionsPlacementExperiment;
	hasMediaMentions: boolean;
	showAboveDecisionMakers: boolean;
}>;

export function useMediaMentionsPlacementExperiment(): Result {
	const {
		data: {
			mediaHitsPage: { mediaHits },
		},
	} = usePetitionDetailsPageData();
	const {
		data: {
			experiments: { petitionPageMediaMentionsPlacement: experiment },
		},
	} = usePetitionDetailsPageUserData();

	// Not the media-hits context: it seeds embeds in an effect, so it reads empty on first render.
	const hasMediaMentions = mediaHits.length > 0;

	const showAboveDecisionMakers = hasMediaMentions && experiment.variation === 'treatment';

	return { experiment, hasMediaMentions, showAboveDecisionMakers };
}
